<template>
  <div class="bg-background flex flex-col min-h-screen">
    <header class="border-b rounded-3xl">
      <div class="container mx-auto px-4 py-4 flex items-center relative">
        <Button variant="ghost" size="sm" @click="router.back()"
          class="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft class="w-4 h-4" />
        </Button>
        <h1 class="text-[1.1rem] font-bold text-foreground absolute left-1/2 -translate-x-1/2 pointer-events-none">
          Termos de Uso
        </h1>
      </div>
    </header>

    <main class="flex-grow container mx-auto px-4 py-8">
      <Card class="max-w-3xl mx-auto">
        <CardHeader>
          <CardTitle class="text-[1.0rem] font-semibold">Por favor, leia atentamente nossos termos</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea class="h-[60vh] pr-4">
            <div class="space-y-4 text-muted-foreground" v-html="tenant.termsOfUse"></div>
          </ScrollArea>
        </CardContent>
      </Card>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ArrowLeft } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useTenant } from '@/composables/useTenant';

const router = useRouter()
const { tenant } = useTenant()
</script>